module.exports = __webpack_public_path__ + "img/fronteira-geologia-logo.6dac37b0.png";